const TemplateTypes = {
	"DEFAULT": 1,
	"FAST_FIVE": 2,
	"SPONSORED_POLL": 3
}

export default TemplateTypes;